/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import axiosInstance from '../services/AxiosInstance';
import TableAddForm from './TableAddForm';
import swal from "sweetalert";
import { Link } from 'react-router-dom';
import ExcelImport from './ExcelImport';
import Pagination from './Pagination';
import InputField from './InputField';
import Loader from "react-js-loader";

const DataTable = ({
  url,
  column,
  filters = '',
  header = [],
  title = '',
  addform = {},
  goback,
  view,
  approve,
  approve_label,
  excelheader,
  excelurl,
  filePath,
  filename,
  extraKey,
  status = ["Approved"],
  viewIcon = 'Click here to view the record',
  edit = true,
  multiDelete = true,
  deny = false,
  deny_label = 'd',
  redList = false,
  deny_status = ['Denied'],
  otherProps
}) => {

  const [modal, setModal] = useState(false);
  const [loader, setLoder] = useState(true);
  const [data, setData] = useState([]);
  const [excelImport, setexcelImport] = useState(false);
  const [pagination, setPagination] = useState();
  const [input, setInput] = useState({});
  const [showSuccess, setShowSuccess] = useState({ "show": false, "msg": "" });
  const [delIds, setDelIds] = useState([]);

  let cancelToken;

  useEffect(() => {
    getData();
  }, [url]);

  const getData = (page = 1) => {
    setLoder(true);
    axiosInstance(
      `${url}?${filters}&page=${page}`, { method: "GET" }
    ).then(res => { setData(res?.data?.results); setPagination({ "pagination": res?.data?.pagination }) })
      .catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
      .finally(() => setLoder(false));
  }

  const handleDelete = () => {
    swal({
      text: "Are you sure that you want to delete this record?",
      icon: "warning",
      dangerMode: true,
    }).then(willDelete => {
      if (willDelete) {
        axiosInstance(`${url}/?delete_ids=${delIds.join(",")}`, { method: "DELETE" })
          .then(res => {
            if (res?.status === 204) {
              getData();
              setDelIds([]);
              swal("", "Deleted Successfully", "success", { button: "Ok!", })
            }
          })
          .catch(err => swal("", err?.response?.data?.detail, { button: "Ok!", }))
      }
    });
  }

  const handleApprove = (id) => {
    axiosInstance(`${url}/${id}/`, { method: "PATCH", data: { [approve_label]: approve } })
      .then(res => {
        if (res.status === 200) {
          getData();
          swal("", "Approved Successfully", "success", { button: "Ok!", })
        }
      }).catch(err => swal("", Object.values(err.response.data), { button: "Ok!", }))
  }

  const handleDeny = (id) => {
    axiosInstance(`${url}/${id}/`, { method: "PATCH", data: { [deny_label]: deny } })
      .then(res => {
        if (res.status === 200) {
          getData();
          swal("", "Denied Successfully", "success", { button: "Ok!", })
        }
      }).catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
  }

  const handleCloseExport = () => {
    setexcelImport(!excelImport);
    getData();
  }

  const handleEdit = (id) => {
    axiosInstance(`${url}/${id}/`, { method: 'GET' }).then(res => {
      setInput(res.data);
      setModal(true);
    })
  }

  const handleSelect = (e, id, name) => {
    if (e.target.checked) {
      setDelIds(delIds => [...delIds, id]);
    } else {
      setDelIds(delIds => delIds.filter(item => item !== id));
    }
    if (name) {
      if (e.target.checked) {
        let ids = [];
        for (let index = 0; index < data?.length; index++) {
          ids.push(data?.[index]?.id);
        }
        setDelIds(ids);
      } else setDelIds([]);
    }
  }

  const handleSearchChange = async e => {
    // Function to cancel previous request on searching for api optimization
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.")
    }
    cancelToken = axios.CancelToken.source()
    try {
      await axiosInstance(
        `${url}?${filters}&search=${e.target.value}`,
        {
          method: "GET",
          cancelToken: cancelToken.token
        }).then(res => {
          setData(res?.data?.results)
        })
    } finally {
      return data
    }
  }

  const handleRedList = (id, value) => {
    axiosInstance(`${url}/${id}/`, { method: 'PATCH', data: { red_listed: value } }).then(res => {
      getData();
      swal("", `${value ? "Red Listed Successfully" : "Removed from Red List Successfully"}`, "success", { button: "Ok!", })
    }).catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
  }

  return (
    <>
      {
        loader ?
          <Loader
            type="spinner-cub"
            bgColor={"#2e55fa"}
            title={"bubble-top"}
            color={'#FFFFFF'}
            size={100}
          />
          :
          <>
            {
              modal &&
              <TableAddForm
                setModal={setModal}
                title={title}
                input={input}
                setInput={setInput}
                addform={addform}
                url={url}
                setShowSuccess={setShowSuccess}
                extraKey={extraKey}
                getData={getData}
              />
            }
            <div className="page-content bg-white">
              <div className="content-block">
                <div className="section-full bg-white p-b20">
                  <div className="container">
                    <div className="job-bx browse-job clearfix">
                      <div className="job-bx-title  clearfix">
                        <h5 className="font-weight-700 pull-left text-uppercase">{title}</h5>
                        {
                          Object.keys(addform).length > 0 && !excelImport &&
                          <div className="float-right">
                            <button
                              className="site-button btn-sm ml-3"
                              onClick={() => ((setModal(true), setShowSuccess(false)))}
                            >
                              Add
                            </button>
                          </div>
                        }
                        {
                          delIds.length > 0 &&
                          <div className="float-right">
                            <button
                              className="site-button btn-sm btn-danger ml-3"
                              onClick={handleDelete}
                              title="Click here to delete the records"
                            >
                              Delete
                            </button>
                          </div>
                        }
                        {
                          goback &&
                          <Link to={goback} className="site-button right-arrow button-sm float-right">Back</Link>
                        }
                        <div className="float-right">
                          {
                            excelheader?.length > 0 &&
                            <span
                              className="float-right mt-1 pointer text-primary"
                              onClick={() => handleCloseExport()}
                              style={{ fontSize: "18px" }}
                            >
                              {excelImport ?
                                <Link to="#" className="site-button right-arrow button-sm float-right">Back</Link>
                                : <i className="fa fa-upload"> Import</i>}
                            </span>
                          }
                        </div>
                        <div className="float-right">
                          <span className="select-title"></span>
                        </div>
                      </div>
                      {
                        excelImport ?
                          <ExcelImport
                            headers={excelheader}
                            url={excelurl}
                            filePath={filePath}
                            filename={filename}
                            handleCloseExport={handleCloseExport}
                          />
                          :
                          <>
                            {showSuccess.show &&
                              <span className="text-danger font-weight-bold">The record is {showSuccess.msg} successfully!</span>
                            }
                            <InputField
                              className="small-input w-25 float-right"
                              placeholder='Search...'
                              onChange={handleSearchChange}
                            />
                            <div className="table-resposive template-table">
                              <table className="table-job-bx cv-manager company-manage-job">
                                <thead>
                                  <tr>
                                    {
                                      multiDelete &&
                                      <th>
                                        <input
                                          type="checkbox"
                                          id="vehicle1"
                                          name="vehicle1"
                                          value="Bike"
                                          checked={data?.length > 0 && data?.length === delIds?.length}
                                          onChange={(e) => handleSelect(e, 'all', 'all')}
                                        />
                                      </th>
                                    }
                                    <th className="feature">#</th>
                                    {
                                      header?.map(res => {
                                        return (
                                          <>
                                            <th key={res}>{res}</th>
                                          </>
                                        )
                                      })
                                    }
                                    <th className="feature text-center p-0">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    <>
                                      {
                                        data.length > 0 &&
                                        data?.map((res, i) => {
                                          var id = +`${pagination?.pagination?.currentPage - 1}0`
                                          return (
                                            <tr key={`${res.id}tr`}>
                                              {
                                                multiDelete &&
                                                <td>
                                                  <input
                                                    type="checkbox"
                                                    name={`select${res?.id}`}
                                                    checked={delIds?.includes(res?.id)}
                                                    onChange={(e) => handleSelect(e, res.id)}
                                                  />
                                                </td>
                                              }
                                              <td className="feature" key={id + i + 1}>{id + i + 1}</td>
                                              {
                                                column.map(col => {
                                                  let data;
                                                  if (typeof res[col] === "boolean") {
                                                    data = res[col] ?
                                                      <i className="fa fa-check" style={{ fontSize: "25px", color: "green" }} />
                                                      : <i className="fa fa-close" style={{ fontSize: "25px", color: "red" }} />;
                                                  } else if (Array.isArray(col)) {
                                                    data = res[col[0]]?.[col[1]]
                                                  }
                                                  else { data = res[col] }
                                                  return <td style={{ wordSpacing: "pre" }}>{data}</td>
                                                })
                                              }
                                              <td className="job-links pr-0" key="viewicon" style={{ display: "flow-root" }}>
                                                {view &&
                                                  otherProps === "employerUsers" ?
                                                  <>
                                                    {res?.institution
                                                      &&
                                                      <Link to={`${view}/${res.institution}`}>
                                                        <i className="fa fa-eye" title={viewIcon} />
                                                      </Link>
                                                    }
                                                  </>
                                                  :
                                                  <Link to={`${view}/${res.id}`}>
                                                    <i className="fa fa-eye" title={viewIcon} />
                                                  </Link>
                                                }
                                                {/* <span onClick={() => handleDelete(res.id)}>
                                            <i className="ti-trash" title='Click here to delete the record' style={{ cursor: "pointer" }} />
                                          </span> */}
                                                {
                                                  edit &&
                                                  <span onClick={() => handleEdit(res.id)}>
                                                    <i className="ti-pencil" title='Click here to edit the record' style={{ cursor: "pointer" }} />
                                                  </span>
                                                }
                                                {
                                                  approve && !(status.includes(res[approve_label])) &&
                                                  <span onClick={() => handleApprove(res.id)} >
                                                    <i className="fa fa-check" title='Click here to approve' style={{ cursor: "pointer" }} />
                                                  </span>
                                                }
                                                {
                                                  deny && !(deny_status.includes(res[approve_label])) &&
                                                  <span onClick={() => handleDeny(res.id)} >
                                                    <i className="fa fa-close" title='Click here to deny' style={{ cursor: "pointer" }} />
                                                  </span>
                                                }
                                                {
                                                  redList &&
                                                  <>
                                                    {
                                                      !(res?.red_listed) ?
                                                        <span onClick={() => handleRedList(res.id, true)}>
                                                          <i className="fa fa-ban text-danger" title='Click here to mark user as red list' style={{ cursor: "pointer" }} />
                                                        </span>
                                                        :
                                                        <span onClick={() => handleRedList(res.id, false)}>
                                                          <i className="fa fa-thumbs-up" title='Click here to unmark user as red list' style={{ cursor: "pointer" }} />
                                                        </span>
                                                    }
                                                  </>
                                                }
                                              </td>
                                            </tr>
                                          )
                                        })}
                                      {
                                        data.length === 0 &&
                                        <tr>
                                          <td colSpan={column.length + 3}>
                                            <div className="alert alert-danger">
                                              <h5 className="text-center">No Data Found</h5>
                                            </div>
                                          </td>
                                        </tr>
                                      }
                                    </>
                                  }
                                </tbody>
                              </table>
                            </div>
                            <div className="m-t10">
                              <Pagination data={pagination} getData={getData} />
                            </div>
                          </>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
      }
    </>
  );
}

export default DataTable;